module.exports = __webpack_public_path__ + "media/fonts/glyphicons-halflings-regular-4692b9ec.ttf";